import { ControlledMaskInput } from '@sravni/cosago-react-library/lib/components';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { forwardRef } from 'react';
import type { ClipboardEvent } from 'react';

import { MaskPlaceholders, Masks } from 'constants/masks';

type Props = IFieldFactoryProps;

export const PhoneField = forwardRef<HTMLDivElement, Props>(({ type, onBlur, ...props }, ref) => {
  /** Нормализация значения при вставке номера, начинающегося на 7 или 8 */
  const onPastePhone = (event: ClipboardEvent<HTMLInputElement>) => {
    const { clipboardData } = event;
    const value = clipboardData.getData('text/plain') || '';

    const paste = value.replace(/\D/g, '').slice(-10);
    document.execCommand('insertText', false, paste);
  };

  /** При полном заполнении номера остаются только числа для прохода валидации.
   *  При частичном заполнении оставляем символы маски,
   *  чтобы можно было редактировать отдельные цифры и они не перезатирались.*/
  const transformOutput = (value: string) => {
    const digitsOnly = value.replace(/\D/g, '');
    if (digitsOnly.length === 11) {
      return digitsOnly;
    }
    return value;
  };

  return (
    <div
      onBlur={onBlur}
      ref={ref}
    >
      <ControlledMaskInput
        {...props}
        name={type}
        mask={Masks.PHONE}
        transformOutput={transformOutput}
        onPaste={onPastePhone}
        inputMode="numeric"
        placeholder={MaskPlaceholders.PHONE}
      />
    </div>
  );
});
